import { render, staticRenderFns } from "./forex.vue?vue&type=template&id=55c39a1e&"
import script from "./forex.vue?vue&type=script&lang=js&"
export * from "./forex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports